import React from 'react'
// import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkBreaks from 'remark-breaks'
import ReactMarkdown from "react-markdown";

 function autoFixBrokenTable(raw) {
  // Extract all | separated tokens
  let parts = raw
    .split("|")
    .map((p) => p.trim())
    .filter((p) => p.length > 0);

  // Expected columns: 3 (like your example)
  const COLS = 3;

  // Case: duplicated --- separator inside input → remove
  parts = parts.filter((p) => p !== "---");

  // Special case: Header exists (first 3 items)
  const header = parts.slice(0, COLS);

  // Remaining rows
  const rows = [];
  for (let i = COLS; i < parts.length; i += COLS) {
    rows.push(parts.slice(i, i + COLS));
  }

  // Build Markdown
  let md = "";

  // Header row
  md += `| ${header.join(" | ")} |\n`;

  // Separator row
  md += `| ${header.map(() => "---").join(" | ")} |\n`;

  // Body rows
  rows.forEach((row) => {
    // pad row if missing cells
    while (row.length < COLS) row.push("");
    md += `| ${row.join(" | ")} |\n`;
  });

  return md;
}
const MarkdownComponent = ({markdown}) => {
  return (
    <ReactMarkdown 
      remarkPlugins={[remarkGfm, remarkBreaks]}
      components={{
        // Paragraphs
        p: ({ children }) => <p className="m-0 mb-2 last:mb-0 leading-relaxed">{children}</p>,
        
        // Text formatting
        strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
        em: ({ children }) => <em className="italic">{children}</em>,
        
        // Links
        a: ({ href, children }) => (
          <a 
            href={href} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 underline break-words"
          >
            {children}
          </a>
        ),
        
        // Lists - Unordered (bullets)
        ul: ({ children }) => (
          <ul className="list-disc list-outside my-2 ml-4 space-y-1">
            {children}
          </ul>
        ),
        
        // Lists - Ordered (numbers)
        ol: ({ children }) => (
          <ol className="list-decimal list-outside my-2 ml-4 space-y-1">
            {children}
          </ol>
        ),
        
        // List items
        li: ({ children }) => (
          <li className="ml-0 leading-relaxed">
            {children}
          </li>
        ),
        
        // Code - inline and blocks
        code: ({ inline, children }) => 
          inline ? (
            <code className="bg-gray-200 px-1.5 py-0.5 rounded text-sm font-mono break-words">
              {children}
            </code>
          ) : (
            <pre className="bg-gray-100 p-3 rounded-lg mt-2 mb-2 overflow-x-auto">
              <code className="text-sm font-mono whitespace-pre">
                {children}
              </code>
            </pre>
          ),
        
        // Blockquotes
        blockquote: ({ children }) => (
          <blockquote className="border-l-4 border-gray-300 pl-4 my-2 italic text-gray-700 bg-gray-50 py-2 rounded-r">
            {children}
          </blockquote>
        ),
        
        // Headings
        h1: ({ children }) => (
          <h1 className="text-lg font-bold mt-4 mb-2 first:mt-0 text-gray-900">
            {children}
          </h1>
        ),
        h2: ({ children }) => (
          <h2 className="text-base font-bold mt-3 mb-2 first:mt-0 text-gray-800">
            {children}
          </h2>
        ),
        h3: ({ children }) => (
          <h3 className="text-sm font-bold mt-2 mb-1 first:mt-0 text-gray-700">
            {children}
          </h3>
        ),
        
        // Tables (supported by remark-gfm)
        // table: ({ children }) => (
        //   <div className="overflow-x-auto my-2">
        //     <table className="min-w-full border-collapse border border-gray-300 text-sm">
        //       {children}
        //     </table>
        //   </div>
        // ),
        thead: ({ children }) => (
          <thead className="bg-gray-100">
            {children}
          </thead>
        ),
        tbody: ({ children }) => (
          <tbody>
            {children}
          </tbody>
        ),
        tr: ({ children }) => (
          <tr className="border-b border-gray-200">
            {children}
          </tr>
        ),
        th: ({ children }) => (
          <th className="border border-gray-300 px-3 py-2 text-left font-semibold">
            {children}
          </th>
        ),
        td: ({ children }) => (
          <td className="border border-gray-300 px-3 py-2">
            {children}
          </td>
        ),
        
        // Horizontal rule
        hr: () => <hr className="my-4 border-gray-300" />,
        
        // Line breaks
        br: () => <br />,
        
        // Strikethrough (supported by remark-gfm)
        del: ({ children }) => (
          <del className="line-through text-gray-500">
            {children}
          </del>
        ),
      }}
    >
      {markdown}
    </ReactMarkdown>
  )
}

export default MarkdownComponent;
